import PropTypes from 'prop-types';

import SideMsg from '#/modules/commonComponents/SideMsg';
import {
  customerOrderSideMsgDetailBlock,
  customerOrderSideMsgStatusBlock,
} from '#/modules/crmMgmt/customerOrder/data/customerOrderSideMsgConfig';

const CustomerOrderSideMsg = ({ displayData }) => {
  const blocks = [
    customerOrderSideMsgStatusBlock,
    customerOrderSideMsgDetailBlock,
  ];

  return (
    <SideMsg
      title="客戶訂單"
      titleValue="customerOrderNo"
      displayData={displayData}
      blocks={blocks}
    />
  );
};

CustomerOrderSideMsg.propTypes = {
  displayData: PropTypes.object,
};

export default CustomerOrderSideMsg;
